import React, { useEffect, useRef } from 'react';
import './Staff.css';

import imgMarco     from '../../assets/staff/staff-marco.png';
import imgJaviera   from '../../assets/staff/staff-javiera.jpg';
import imgMaria     from '../../assets/staff/staff-maria.jpg';
import imgJuan      from '../../assets/staff/staff-juan.jpg';
import imgJose      from '../../assets/staff/staff-jose.jpg';
import imgCristobal from '../../assets/staff/staff-cristobal.jpg';
import imgDaniela   from '../../assets/staff/staff-daniela.jpg';
import imgFrancisco from '../../assets/staff/staff-francisco.jpg';

const staffMembers = [
  {
    name: 'Javiera Guerrero',
    role: 'Psicóloga Deportiva',
    specialty: 'Encargada de prácticas y proyectos profesionales',
    image: imgJaviera,
  },
  {
    name: 'María de los Ángeles',
    role: 'Psicóloga Deportiva',
    specialty: 'Especialista en deportes grupales e individuales',
    image: imgMaria,
  },
  {
    name: 'Juan Langlois',
    role: 'Psicólogo Deportivo',
    specialty: 'Especialista en deportes individuales',
    image: imgJuan,
  },
  {
    name: 'José Ábalos',
    role: 'Psicólogo Deportivo',
    specialty: 'Especialista en alto rendimiento',
    image: imgJose,
  },
  {
    name: 'Cristóbal Mansilla',
    role: 'Psicólogo Deportivo',
    specialty: 'Especialista en alto rendimiento',
    image: imgCristobal,
  },
  {
    name: 'Daniela López',
    role: 'Psicóloga Deportiva',
    specialty: 'Especialista en alto rendimiento',
    image: imgDaniela,
  },
  {
    name: 'Francisco Heresi',
    role: 'Coach Deportivo',
    specialty: 'Especialista en deportes grupales',
    image: imgFrancisco,
  },
  {
    name: 'Katherine Heresi',
    role: 'Psicóloga Clínica',
    specialty: 'Especialista en adolescentes y adultos',
    image: null,
  },
];

const Staff = () => {
  const directorRef = useRef(null);
  const cardsRef    = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('visible')),
      { threshold: 0.1 }
    );
    if (directorRef.current) observer.observe(directorRef.current);
    cardsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="staff-page">

      {/* ── HEADER ── */}
      <header className="staff-header">
        <div className="staff-header__inner">
          <h1 className="staff-header__title">Nuestro Staff</h1>
          <p className="staff-header__subtitle">
            El equipo de profesionales detrás del Programa Mente Ganadora
          </p>
        </div>
        <div className="staff-header__bar" />
      </header>

      {/* ── DIRECTOR ── */}
      <section className="staff-director-section">
        <div
          ref={directorRef}
          className="staff-director fade-up"
        >
          <div className="staff-director__img-wrap">
            <img src={imgMarco} alt="Marco Garrido" />
          </div>
          <div className="staff-director__info">
            <span className="staff-director__label">Director</span>
            <h2 className="staff-director__name">Marco Garrido</h2>
            <p className="staff-director__role">Programa Mente Ganadora</p>
            <div className="staff-director__divider" />
            <p className="staff-director__specialty">Especialista en alto rendimiento</p>
          </div>
        </div>
      </section>

      {/* ── EQUIPO ── */}
      <section className="staff-team-section">
        <h2 className="staff-team-section__heading">Equipo Profesional</h2>
        <div className="staff-grid">
          {staffMembers.map((member, i) => (
            <div
              key={i}
              ref={(el) => (cardsRef.current[i] = el)}
              className="staff-card fade-up"
              style={{ transitionDelay: `${(i % 4) * 0.08}s` }}
            >
              <div className="staff-card__img-wrap">
                {member.image ? (
                  <img src={member.image} alt={member.name} />
                ) : (
                  <div className="staff-card__placeholder">
                    <span>{member.name.charAt(0)}</span>
                  </div>
                )}
              </div>
              <div className="staff-card__info">
                <h3 className="staff-card__name">{member.name}</h3>
                <p className="staff-card__role">{member.role}</p>
                <p className="staff-card__specialty">{member.specialty}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

    </div>
  );
};

export default Staff;
